(function () {
    "use strict";

    var STORAGE_KEY = "campaign_params";

    var FIELD_MAP = {
        utm_source: "UTMSource",
        utm_medium: "UTMMedium",
        utm_campaign: "UTMCampaign",
        utm_content: "UTMContent",
    };

    function parseQueryString() {
        var params = {};
        var search = window.location.search;
        if (!search || search.length < 2) return params;

        if (typeof URLSearchParams !== "undefined") {
            var usp = new URLSearchParams(search);
            usp.forEach(function (value, key) {
                params[key.toLowerCase()] = value;
            });
        } else {
            var pairs = search.substring(1).split("&");
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i].split("=");
                if (pair[0]) {
                    params[decodeURIComponent(pair[0]).toLowerCase()] =
                        pair[1] ? decodeURIComponent(pair[1].replace(/\+/g, " ")) : "";
                }
            }
        }
        return params;
    }

    function hasRelevantParams(incoming) {
        var campaignKeys = Object.keys(FIELD_MAP);
        for (var i = 0; i < campaignKeys.length; i++) {
            if (incoming.hasOwnProperty(campaignKeys[i])) return true;
        }
        return false;
    }

    function readStored() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (e) {
            return {};
        }
    }

    function storeParams(incoming) {
        var campaignKeys = Object.keys(FIELD_MAP);
        var existing = readStored();

        var merged = {};
        for (var key in existing) {
            if (existing.hasOwnProperty(key)) merged[key] = existing[key];
        }
        for (var i = 0; i < campaignKeys.length; i++) {
            var qsKey = campaignKeys[i];
            if (incoming.hasOwnProperty(qsKey)) {
                merged[qsKey] = incoming[qsKey];
            }
        }

        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
        } catch (e) {
            console.warn("[CampaignTracker] Could not write to localStorage:", e);
        }

        return merged;
    }

    function liveFormExists() {
        return !!document.querySelector('[id*="LiveForm"], [class*="LiveForm"]');
    }

    function populateLiveFormFields(data) {
        if (!data) return;

        if (!liveFormExists()) return;

        var campaignKeys = Object.keys(FIELD_MAP);
        var labels = document.querySelectorAll("label");

        for (var i = 0; i < campaignKeys.length; i++) {
            var qsKey = campaignKeys[i];
            var labelText = FIELD_MAP[qsKey];
            var value = data[qsKey];

            if (!value) continue;

            for (var j = 0; j < labels.length; j++) {
                if (labels[j].textContent.trim() === labelText) {
                    var forAttr = labels[j].getAttribute("for");
                    if (forAttr) {
                        var input = document.getElementById(forAttr);
                        if (input) input.value = value;
                    }
                    break;
                }
            }
        }
    }

    function init() {
        var incoming = parseQueryString();
        var data;

        if (hasRelevantParams(incoming)) {
            data = storeParams(incoming);
        } else {
            data = readStored();
        }

        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", function () {
                populateLiveFormFields(data);
            });
        } else {
            populateLiveFormFields(data);
        }
    }

    init();

})();